/** @jsx jsx */
import {Heading, jsx, Flex, Box} from 'theme-ui'
import {animated, useSpring, config} from 'react-spring'
import {Link} from 'gatsby'
// import { useStaticQuery, graphql } from "gatsby"
// import Img from "gatsby-image"
import AboutMeMDX from '../texts/about-me.mdx'
import useEmiliaConfig from '@lekoarts/gatsby-theme-emilia/src/hooks/use-emilia-config'
import HeaderBackground from '@lekoarts/gatsby-theme-emilia/src/components/header-background'
import Location from '@lekoarts/gatsby-theme-emilia/src/assets/location'
import SocialMediaList from '@lekoarts/gatsby-theme-emilia/src/components/social-media-list'

const Header = ({small}) => {
  const {name, location, assetsPath} = useEmiliaConfig()
  // const avatar = useStaticQuery(graphql`
  //   query {
  //     file(name: { eq: "avatar" }) {
  //       childImageSharp {
  //         fixed(width: 140, height: 140, quality: 100) {
  //           ...GatsbyImageSharpFixed_withWebp
  //         }
  //       }
  //     }
  //   }
  // `)

  const fadeUpProps = useSpring({
    config: config.slow,
    from: {opacity: 0, transform: `translate3d(0, 30px, 0)`},
    to: {opacity: 1, transform: `translate3d(0, 0, 0)`},
  })
  const fadeUpPropsDelay = useSpring({
    config: config.slow,
    delay: 250,
    from: {opacity: 0, transform: `translate3d(0, 30px, 0)`},
    to: {opacity: 1, transform: `translate3d(0, 0, 0)`},
  })
  const fadeProps = useSpring({config: config.slow, from: {opacity: 0}, to: {opacity: 1}})
  const fadeLongProps = useSpring({config: config.slow, delay: 600, from: {opacity: 0}, to: {opacity: 1}})

  return (
    <Flex as='header' variant='layout.projectHead'>
      <HeaderBackground />
      <Flex
        sx={{
          flexDirection: ['column', 'row'],
          mb: [6, 1],
          height: small ? ['18rem', '16rem', '16rem', '14rem'] : undefined,
        }}
      >
        <Box sx={{textAlign: [null, null, 'center'], my: [3, 5], mx: 3, zIndex: 10}}>
          {/* <animated.div style={fadeProps}>
          <div
            sx={{
              overflow: `hidden`,
              borderRadius: `full`,
              height: [`100px`, `140px`],
              width: [`100px`, `140px`],
              display: `inline-block`,
              boxShadow: `lg`,
              "> div:not([data-placeholder='true'])": {
                height: [`100px !important`, `140px !important`],
                width: [`100px !important`, `140px !important`],
              },
            }}
          >
            {avatar && avatar.file && avatar.file.childImageSharp ? (
              <Img fixed={avatar.file.childImageSharp.fixed} />
            ) : (
              <div
                sx={{
                  fontSize: 0,
                  position: `absolute`,
                  top: 0,
                  left: 0,
                  width: `100% !important`,
                  right: 0,
                  p: 3,
                  backgroundColor: `red.2`,
                }}
                data-placeholder="true"
              >
                Place an image with the name "avatar" inside the directory "{assetsPath}"
              </div>
            )}
          </div>
        </animated.div> */}
          <animated.div style={fadeUpProps}>
            <Heading as='h1' variant='styles.h1'>
              <Link style={{textDecoration: 'none', color: 'inherit'}} to='/'>
                {name}
              </Link>
            </Heading>
          </animated.div>
          <animated.div style={fadeUpPropsDelay}>
            <div
              sx={{
                svg: {
                  width: `20px`,
                  height: `20px`,
                  '.primary': {color: `iconPrimary`},
                  '.secondary': {color: `iconSecondary`},
                  mr: 2,
                },
                display: `flex`,
                alignItems: `center`,
                color: `text`,
              }}
            >
              <Location /> {location}
            </div>
          </animated.div>
          <div data-testid='social-header' sx={{mt: 3, mb: [2, 6], textAlign: 'initial', a: {mr: 2}}}>
            <animated.div style={fadeLongProps}>
              <SocialMediaList />
            </animated.div>
          </div>
        </Box>
        <Box
          sx={{
            textAlign: ['left'],
            my: [2, 5],
            mx: ['5vw', null, null, '10vw'],
            zIndex: 10,
            maxWidth: '40vw',
            minWidth: 200,
            // textIndent: 15,
            alignSelf: ['center', 'auto'],
          }}
        >
          <AboutMeMDX />
        </Box>
      </Flex>
    </Flex>
  )
}

export default Header
